import type { SupportStatus } from '../services/support-api';

const RTF = new Intl.RelativeTimeFormat('ro', { numeric: 'auto' });

export function formatRelativeTime(iso: string | Date): string {
  const date = typeof iso === 'string' ? new Date(iso) : iso;
  const diff = (date.getTime() - Date.now()) / 1000;
  const abs = Math.abs(diff);
  if (abs < 60) return RTF.format(Math.round(diff), 'second');
  if (abs < 3600) return RTF.format(Math.round(diff / 60), 'minute');
  if (abs < 86400) return RTF.format(Math.round(diff / 3600), 'hour');
  if (abs < 604800) return RTF.format(Math.round(diff / 86400), 'day');
  return date.toLocaleDateString('ro-RO', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function statusLabel(status: SupportStatus): string {
  const map: Record<SupportStatus, string> = {
    open: 'Deschis',
    pending_user: 'Te așteaptă',
    pending_agent: 'În lucru',
    resolved: 'Rezolvat',
    closed: 'Închis',
  };
  return map[status] ?? status;
}

export function statusToneClasses(status: SupportStatus): string {
  const map: Record<SupportStatus, string> = {
    open: 'bg-amber-100 text-amber-800 dark:bg-amber-950/40 dark:text-amber-300',
    pending_user: 'bg-sky-100 text-sky-800 dark:bg-sky-950/40 dark:text-sky-300',
    pending_agent:
      'bg-violet-100 text-violet-800 dark:bg-violet-950/40 dark:text-violet-300',
    resolved:
      'bg-emerald-100 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-300',
    closed:
      'bg-neutral-100 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-400',
  };
  return map[status] ?? map.open;
}
